<p-dialog
    appDialogoPadrao="pi pi-check-square"
    descricao="Escolha quem entra no relatório."
    header="Selecionar Profissionais"
    [visible]="visible()"
    (visibleChange)="visible.set($event)"
    [style]="{ width: '70vw', maxWidth: '800px' }"
    [closeOnEscape]="true"
>
    <div class="flex flex-col gap-5">
        <!-- ── Busca rápida + Filtros Avançados ── -->
        <div class="flex flex-col md:flex-row gap-3">
            <div class="relative flex-grow">
                <i class="pi pi-search absolute left-4 top-1/2 -translate-y-1/2 text-slate-400 text-sm" aria-hidden="true"></i>
                <input
                    type="text"
                    [(ngModel)]="filters.nmSolicitante"
                    class="w-full pl-10 pr-4 py-3 bg-slate-50 hover:bg-slate-100/50 focus:bg-white border border-slate-200 focus:border-green-600 focus:ring-2 focus:ring-green-500/20 rounded-xl text-sm font-semibold transition-all outline-none"
                    placeholder="Busca rápida por nome do médico..."
                    aria-label="Busca por nome do médico"
                    (keyup.enter)="pesquisar()"
                />
            </div>
            <p-button (click)="toggleFilters()" icon="pi pi-sliders-h" label="Filtros Avançados" [outlined]="filtersOpen()" [text]="!filtersOpen()" class="shrink-0" />
            <p-button (click)="pesquisar()" [loading]="searchLoading()" icon="pi pi-search" label="Pesquisar" class="shrink-0" />
            @if (activeFilterCount() > 0) {
                <p-button [text]="true" severity="secondary" (click)="limparFiltros()" icon="pi pi-eraser" label="Limpar" size="small" class="shrink-0" />
            }
        </div>

        <!-- ── Painel de filtros avançados ── -->
        @if (filtersOpen()) {
            <div class="pt-4 border-t border-slate-100">
                <p-tabs value="0">
                    <p-tablist>
                        <p-tab value="0">Médico</p-tab>
                        <p-tab value="1">Tipo de Inscrição</p-tab>
                        <p-tab value="2">Histórico</p-tab>
                        <p-tab value="3">Formação</p-tab>
                        <p-tab value="4">Especialidade</p-tab>
                        <p-tab value="5">Local</p-tab>
                    </p-tablist>
                    <p-tabpanels>
                        <!-- ── Aba 1: Médico ── -->
                        <p-tabpanel value="0">
                            <div class="grid grid-cols-1 md:grid-cols-12 gap-4 pt-3">
                                <div class="md:col-span-4">
                                    <label class="block text-[10px] font-extrabold text-slate-400 uppercase tracking-wider mb-2" for="spNuCrm">Nº CRM</label>
                                    <input
                                        id="spNuCrm"
                                        type="text"
                                        [(ngModel)]="filters.nuCrm"
                                        class="w-full px-4 py-2.5 bg-slate-50 hover:bg-slate-100/50 focus:bg-white border border-slate-200 focus:border-green-600 rounded-xl text-xs font-semibold transition-all outline-none"
                                        placeholder="Ex: 17203"
                                    />
                                </div>
                                <div class="md:col-span-4">
                                    <label class="block text-[10px] font-extrabold text-slate-400 uppercase tracking-wider mb-2" for="spUf">UF Inscrição</label>
                                    <p-select inputId="spUf" [(ngModel)]="filters.sgUf" [options]="UF_SELECT_OPTIONS" optionLabel="label" optionValue="value" [appendTo]="'body'" class="w-full" ariaLabel="UF Inscrição" />
                                </div>
                                <div class="md:col-span-4">
                                    <label class="block text-[10px] font-extrabold text-slate-400 uppercase tracking-wider mb-2" for="spInAtivo">Status</label>
                                    <p-select
                                        inputId="spInAtivo"
                                        [(ngModel)]="filters.inAtivo"
                                        [options]="STATUS_ATIVO_OPTIONS"
                                        optionLabel="label"
                                        optionValue="value"
                                        [appendTo]="'body'"
                                        class="w-full"
                                        ariaLabel="Status ativo"
                                        (ngModelChange)="onStatusChange($event)"
                                    />
                                </div>
                                <div class="md:col-span-4">
                                    <label class="block text-[10px] font-extrabold text-slate-400 uppercase tracking-wider mb-2" for="spCpf">CPF</label>
                                    <input
                                        id="spCpf"
                                        type="text"
                                        [(ngModel)]="filters.nuCpfCgc"
                                        class="w-full px-4 py-2.5 bg-slate-50 hover:bg-slate-100/50 focus:bg-white border border-slate-200 focus:border-green-600 rounded-xl text-xs font-semibold transition-all outline-none"
                                        placeholder="Ex: 123.456.789-01"
                                    />
                                </div>
                                <div class="md:col-span-4">
                                    <label class="block text-[10px] font-extrabold text-slate-400 uppercase tracking-wider mb-2" for="spRg">RG</label>
                                    <input
                                        id="spRg"
                                        type="text"
                                        [(ngModel)]="filters.nuRg"
                                        class="w-full px-4 py-2.5 bg-slate-50 hover:bg-slate-100/50 focus:bg-white border border-slate-200 focus:border-green-600 rounded-xl text-xs font-semibold transition-all outline-none"
                                        placeholder="Nº do RG"
                                    />
                                </div>
                                <div class="md:col-span-4">
                                    <label class="block text-[10px] font-extrabold text-slate-400 uppercase tracking-wider mb-2" for="spSituacao">Situação</label>
                                    <p-select inputId="spSituacao" [(ngModel)]="filters.dsSituacao" [options]="situacaoOptions()" optionLabel="label" optionValue="value" [appendTo]="'body'" class="w-full" ariaLabel="Situação" />
                                </div>
                                <div class="md:col-span-4">
                                    <label class="block text-[10px] font-extrabold text-slate-400 uppercase tracking-wider mb-2" for="spCategoria">Categoria</label>
                                    <p-select inputId="spCategoria" [(ngModel)]="filters.inCategoria" [options]="CATEGORIA_MILITAR_OPTIONS" optionLabel="label" optionValue="value" [appendTo]="'body'" class="w-full" ariaLabel="Categoria" />
                                </div>
                                <div class="md:col-span-4">
                                    <label class="block text-[10px] font-extrabold text-slate-400 uppercase tracking-wider mb-2" for="spSexo">Sexo</label>
                                    <p-select inputId="spSexo" [(ngModel)]="filters.sgSexo" [options]="SEXO_OPTIONS" optionLabel="label" optionValue="value" [appendTo]="'body'" class="w-full" ariaLabel="Sexo" />
                                </div>
                                <div class="md:col-span-4">
                                    <label class="block text-[10px] font-extrabold text-slate-400 uppercase tracking-wider mb-2" for="spNascInicio">Nascimento De</label>
                                    <p-date-picker inputId="spNascInicio" [(ngModel)]="filters.dtNascimentoInicio" dateFormat="dd/mm/yy" dataType="date" [appendTo]="'body'" fluid placeholder="dd/mm/aaaa" [showClear]="true" />
                                </div>
                                <div class="md:col-span-4">
                                    <label class="block text-[10px] font-extrabold text-slate-400 uppercase tracking-wider mb-2" for="spNascFim">Nascimento Até</label>
                                    <p-date-picker inputId="spNascFim" [(ngModel)]="filters.dtNascimentoFim" dateFormat="dd/mm/yy" dataType="date" [appendTo]="'body'" fluid placeholder="dd/mm/aaaa" [showClear]="true" />
                                </div>
                                <div class="md:col-span-12 flex items-center gap-6 pt-1">
                                    <div class="flex items-center gap-3 cursor-pointer select-none">
                                        <p-checkbox [(ngModel)]="filters.inJubilado" [binary]="true" inputId="spJubilado" />
                                        <label for="spJubilado" class="text-xs font-semibold text-slate-600 cursor-pointer">Jubilado</label>
                                    </div>
                                    <div class="flex items-center gap-3 cursor-pointer select-none">
                                        <p-checkbox [(ngModel)]="filters.inDeficiente" [binary]="true" inputId="spPcd" />
                                        <label for="spPcd" class="text-xs font-semibold text-slate-600 cursor-pointer">PCD</label>
                                    </div>
                                </div>
                            </div>
                        </p-tabpanel>

                        <!-- ── Aba 2: Tipo de Inscrição ── -->
                        <p-tabpanel value="1">
                            <div class="grid grid-cols-1 md:grid-cols-12 gap-4 pt-3">
                                <div class="md:col-span-12">
                                    <label class="block text-[10px] font-extrabold text-slate-400 uppercase tracking-wider mb-2" for="spTipoInscricao">Tipo de Inscrição</label>
                                    <p-select
                                        inputId="spTipoInscricao"
                                        [(ngModel)]="filters.inTipoInscricao"
                                        [options]="TIPO_INSCRICAO_OPTIONS"
                                        optionLabel="label"
                                        optionValue="value"
                                        [appendTo]="'body'"
                                        class="w-full"
                                        ariaLabel="Tipo de inscrição"
                                    />
                                </div>
                                <div class="md:col-span-6">
                                    <label class="block text-[10px] font-extrabold text-slate-400 uppercase tracking-wider mb-2" for="spInscricaoInicio">Data de Inscrição De</label>
                                    <p-date-picker inputId="spInscricaoInicio" [(ngModel)]="filters.dtInscricaoInicio" dateFormat="dd/mm/yy" dataType="date" [appendTo]="'body'" fluid placeholder="dd/mm/aaaa" [showClear]="true" />
                                </div>
                                <div class="md:col-span-6">
                                    <label class="block text-[10px] font-extrabold text-slate-400 uppercase tracking-wider mb-2" for="spInscricaoFim">Data de Inscrição Até</label>
                                    <p-date-picker inputId="spInscricaoFim" [(ngModel)]="filters.dtInscricaoFim" dateFormat="dd/mm/yy" dataType="date" [appendTo]="'body'" fluid placeholder="dd/mm/aaaa" [showClear]="true" />
                                </div>
                            </div>
                        </p-tabpanel>

                        <!-- ── Aba 3: Histórico de Inscrição ── -->
                        <p-tabpanel value="2">
                            <div class="grid grid-cols-1 md:grid-cols-12 gap-4 pt-3">
                                <div class="md:col-span-4">
                                    <label class="block text-[10px] font-extrabold text-slate-400 uppercase tracking-wider mb-2" for="spUfTransferencia">UF Transferência</label>
                                    <p-select
                                        inputId="spUfTransferencia"
                                        [(ngModel)]="filters.sgUfTransferencia"
                                        [options]="UF_SELECT_OPTIONS"
                                        optionLabel="label"
                                        optionValue="value"
                                        [appendTo]="'body'"
                                        class="w-full"
                                        ariaLabel="UF de transferência"
                                    />
                                </div>
                                <div class="md:col-span-6">
                                    <label class="block text-[10px] font-extrabold text-slate-400 uppercase tracking-wider mb-2" for="spHistoricoInicio">Período De</label>
                                    <p-date-picker inputId="spHistoricoInicio" [(ngModel)]="filters.dtHistoricoInicio" dateFormat="dd/mm/yy" dataType="date" [appendTo]="'body'" fluid placeholder="dd/mm/aaaa" [showClear]="true" />
                                </div>
                                <div class="md:col-span-6">
                                    <label class="block text-[10px] font-extrabold text-slate-400 uppercase tracking-wider mb-2" for="spHistoricoFim">Período Até</label>
                                    <p-date-picker inputId="spHistoricoFim" [(ngModel)]="filters.dtHistoricoFim" dateFormat="dd/mm/yy" dataType="date" [appendTo]="'body'" fluid placeholder="dd/mm/aaaa" [showClear]="true" />
                                </div>
                            </div>
                        </p-tabpanel>

                        <!-- ── Aba 4: Formação ── -->
                        <p-tabpanel value="3">
                            <div class="grid grid-cols-1 md:grid-cols-12 gap-4 pt-3">
                                <div class="md:col-span-8">
                                    <label class="block text-[10px] font-extrabold text-slate-400 uppercase tracking-wider mb-2" for="spEscola">Escola / Faculdade</label>
                                    <div class="flex items-center gap-2">
                                        <input
                                            pInputText
                                            id="spEscola"
                                            type="text"
                                            [ngModel]="escolaLabel()"
                                            readonly
                                            class="w-full px-4 py-2.5 bg-slate-50 border border-slate-200 rounded-xl text-xs font-semibold outline-none"
                                            placeholder="Nenhuma escola selecionada"
                                            aria-label="Escola selecionada"
                                        />
                                        <p-button icon="pi pi-search" [text]="true" ariaLabel="Buscar escola" (click)="pesquisaEscolaVisible.set(true)" />
                                        <p-button icon="pi pi-times" [text]="true" severity="danger" ariaLabel="Remover escola" [disabled]="!filters.idEscolaFormacao" (click)="limparEscola()" />
                                    </div>
                                </div>
                                <div class="md:col-span-4">
                                    <label class="block text-[10px] font-extrabold text-slate-400 uppercase tracking-wider mb-2" for="spUfFormacao">UF Formação</label>
                                    <p-select inputId="spUfFormacao" [(ngModel)]="filters.sgUfFormacao" [options]="UF_SELECT_OPTIONS" optionLabel="label" optionValue="value" [appendTo]="'body'" class="w-full" ariaLabel="UF de formação" />
                                </div>
                                <div class="md:col-span-4">
                                    <label class="block text-[10px] font-extrabold text-slate-400 uppercase tracking-wider mb-2" for="spFormaturaInicio">Formatura De</label>
                                    <p-date-picker inputId="spFormaturaInicio" [(ngModel)]="filters.dtFormaturaInicio" dateFormat="dd/mm/yy" dataType="date" [appendTo]="'body'" fluid placeholder="dd/mm/aaaa" [showClear]="true" />
                                </div>
                                <div class="md:col-span-4">
                                    <label class="block text-[10px] font-extrabold text-slate-400 uppercase tracking-wider mb-2" for="spFormaturaFim">Formatura Até</label>
                                    <p-date-picker inputId="spFormaturaFim" [(ngModel)]="filters.dtFormaturaFim" dateFormat="dd/mm/yy" dataType="date" [appendTo]="'body'" fluid placeholder="dd/mm/aaaa" [showClear]="true" />
                                </div>
                                <div class="md:col-span-4">
                                    <label class="block text-[10px] font-extrabold text-slate-400 uppercase tracking-wider mb-2" for="spApresentouDiploma">Apresentou Diploma</label>
                                    <p-select
                                        inputId="spApresentouDiploma"
                                        [(ngModel)]="filters.inApresentouDiploma"
                                        [options]="APRESENTOU_DIPLOMA_OPTIONS"
                                        optionLabel="label"
                                        optionValue="value"
                                        [appendTo]="'body'"
                                        class="w-full"
                                        ariaLabel="Apresentou diploma"
                                    />
                                </div>
                            </div>
                        </p-tabpanel>

                        <!-- ── Aba 5: Especialidade ── -->
                        <p-tabpanel value="4">
                            <div class="grid grid-cols-1 md:grid-cols-12 gap-4 pt-3">
                                <div class="md:col-span-6">
                                    <label class="block text-[10px] font-extrabold text-slate-400 uppercase tracking-wider mb-2" for="spEspecialidade">Especialidade</label>
                                    <p-select
                                        inputId="spEspecialidade"
                                        [(ngModel)]="filters.idEspecialidade"
                                        [options]="especialidadeOptions()"
                                        optionLabel="label"
                                        optionValue="value"
                                        [appendTo]="'body'"
                                        class="w-full"
                                        ariaLabel="Especialidade"
                                        (onChange)="onEspecialidadeChange()"
                                    />
                                </div>
                                <div class="md:col-span-6">
                                    <label class="block text-[10px] font-extrabold text-slate-400 uppercase tracking-wider mb-2" for="spAreaAtuacao">Área de Atuação</label>
                                    <p-select
                                        inputId="spAreaAtuacao"
                                        [(ngModel)]="filters.idAreaAtuacao"
                                        [options]="areaAtuacaoOptions()"
                                        optionLabel="label"
                                        optionValue="value"
                                        [appendTo]="'body'"
                                        class="w-full"
                                        ariaLabel="Área de atuação"
                                        [disabled]="!filters.idEspecialidade"
                                    />
                                </div>
                                <div class="md:col-span-6">
                                    <label class="block text-[10px] font-extrabold text-slate-400 uppercase tracking-wider mb-2" for="spPerito">Perito</label>
                                    <p-select inputId="spPerito" [(ngModel)]="filters.inPerito" [options]="TIPO_PERITO_OPTIONS" optionLabel="label" optionValue="value" [appendTo]="'body'" class="w-full" ariaLabel="Perito" />
                                </div>
                            </div>
                        </p-tabpanel>

                        <!-- ── Aba 6: Local ── -->
                        <p-tabpanel value="5">
                            <div class="grid grid-cols-1 md:grid-cols-12 gap-4 pt-3">
                                <div class="md:col-span-12">
                                    <label class="block text-[10px] font-extrabold text-slate-400 uppercase tracking-wider mb-2">Tipo de Abrangência</label>
                                    <p-select [(ngModel)]="filters.tipoLocalAbrangencia" [options]="TIPO_LOCAL_OPTIONS" optionLabel="label" optionValue="value" [appendTo]="'body'" class="w-full md:w-64" ariaLabel="Tipo de abrangência" />
                                </div>
                                @if (filters.tipoLocalAbrangencia === ETipoLocalAbrangencia.MUNICIPIO) {
                                    <div class="md:col-span-12">
                                        <label class="block text-[10px] font-extrabold text-slate-400 uppercase tracking-wider mb-2" for="spMunicipio">Município</label>
                                        <input
                                            id="spMunicipio"
                                            type="text"
                                            [(ngModel)]="filters.nmMunicipio"
                                            class="w-full px-4 py-2.5 bg-slate-50 hover:bg-slate-100/50 focus:bg-white border border-slate-200 focus:border-green-600 rounded-xl text-xs font-semibold transition-all outline-none"
                                            placeholder="Nome do município"
                                        />
                                    </div>
                                }
                                @if (filters.tipoLocalAbrangencia === ETipoLocalAbrangencia.DELEGACIA) {
                                    <div class="md:col-span-12">
                                        <label class="block text-[10px] font-extrabold text-slate-400 uppercase tracking-wider mb-2" for="spDelegacia">Delegacia</label>
                                        <input
                                            id="spDelegacia"
                                            type="text"
                                            [(ngModel)]="filters.nmDelegacia"
                                            class="w-full px-4 py-2.5 bg-slate-50 hover:bg-slate-100/50 focus:bg-white border border-slate-200 focus:border-green-600 rounded-xl text-xs font-semibold transition-all outline-none"
                                            placeholder="Nome da delegacia"
                                        />
                                    </div>
                                }
                            </div>
                        </p-tabpanel>
                    </p-tabpanels>
                </p-tabs>
            </div>
        }

        <!-- ── Lista de resultados ── -->
        <div>
            <div class="flex items-center justify-between mb-3">
                <span class="text-xs font-bold text-slate-500">
                    @if (searched()) {
                        {{ medicosList().length }} resultado(s){{ resultadoTruncado() ? ' — limitado a 200, refine a pesquisa' : '' }}
                    } @else {
                        Pesquise para listar médicos
                    }
                </span>
                <div class="flex items-center gap-2">
                    @if (medicosList().length > 0) {
                        <p-button [text]="true" size="small" (click)="selecionarTodos()" icon="pi pi-check-square" label="Marcar Todos" />
                    }
                    @if (totalSelecionados() > 0) {
                        <span class="text-xs font-bold bg-green-100 text-green-800 px-2.5 py-0.5 rounded-full border border-green-200"> {{ totalSelecionados() }} selecionado(s) </span>
                        <p-button [text]="true" severity="danger" size="small" (click)="desmarcarTodos()" icon="pi pi-times" label="Desmarcar" />
                    }
                </div>
            </div>

            @if (searchLoading()) {
                <div class="border border-slate-200 rounded-xl overflow-hidden">
                    @for (i of [1, 2, 3, 4, 5, 6]; track i) {
                        <div class="flex items-center gap-3 px-3 py-2.5 border-b border-slate-100 animate-pulse last:border-b-0">
                            <div class="w-4 h-4 bg-slate-200 rounded shrink-0"></div>
                            <div class="w-7 h-7 bg-slate-200 rounded-full shrink-0"></div>
                            <div class="flex-grow space-y-1.5">
                                <div class="h-3 bg-slate-200 rounded w-2/3"></div>
                                <div class="h-2 bg-slate-100 rounded w-1/3"></div>
                            </div>
                            <div class="h-4 w-16 bg-slate-200 rounded shrink-0"></div>
                        </div>
                    }
                </div>
            } @else if (!searched()) {
                <div class="py-8 text-center space-y-2">
                    <i class="pi pi-search text-4xl text-slate-200 block" aria-hidden="true"></i>
                    <p class="text-xs font-semibold text-slate-400">Use os filtros acima e clique em "Pesquisar".</p>
                </div>
            } @else if (medicosList().length === 0) {
                <div class="py-8 text-center space-y-2">
                    <i class="pi pi-user-minus text-4xl text-slate-200 block" aria-hidden="true"></i>
                    <p class="text-xs font-semibold text-slate-400">Nenhum médico encontrado.</p>
                </div>
            } @else {
                <p-table [value]="medicosList()" stripedRows [scrollable]="true" scrollHeight="220px" [ariaLabel]="'Resultados da pesquisa de médicos'">
                    <ng-template pTemplate="body" let-medico>
                        <tr>
                            <td style="width: 3rem">
                                <p-checkbox [binary]="true" [ngModel]="isSelecionado(medico)" (onChange)="toggleSelecionado(medico)" [ariaLabel]="'Selecionar ' + medico.nmSolicitante + ', CRM ' + medico.nuCrmFormatado" />
                            </td>
                            <td class="cursor-pointer" (click)="toggleSelecionado(medico)">
                                <div class="flex items-center gap-2.5 min-w-0">
                                    <app-pessoa-avatar [crm]="medico.nuCrm" [uf]="medico.sgUf" [nome]="medico.nmSolicitante" tamanho="sm" />
                                    <div class="min-w-0">
                                        <span class="text-xs font-bold block leading-tight truncate">{{ medico.nmSolicitante | titlecase }}</span>
                                        <span class="text-[10px] text-color-secondary">
                                            CRM {{ medico.nuCrmFormatado }}
                                            @if (medico.dsEspecialidadePrincipal) {
                                                · {{ medico.dsEspecialidadePrincipal }}
                                            }
                                        </span>
                                    </div>
                                </div>
                            </td>
                            <td style="width: 9rem" class="text-right">
                                <span class="situacao-badge" [class]="'situacao-badge--' + situacaoSeveridade(medico.dsSituacao)">
                                    {{ medico.dsSituacao }}
                                </span>
                            </td>
                        </tr>
                    </ng-template>
                </p-table>
            }
        </div>
    </div>

    <ng-template pTemplate="footer">
        <p-button label="Cancelar" [text]="true" severity="secondary" (click)="cancelar()" />
        <p-button label="Adicionar à Fila" icon="pi pi-check" [disabled]="totalSelecionados() === 0" (click)="confirmar()" />
    </ng-template>
</p-dialog>

<app-pesquisar-escola-dialog [(showDialog)]="pesquisaEscolaVisible" [tipo]="'GRAD'" (saved)="selecionarEscola($event)" />
